module.exports = __webpack_public_path__ + "static/media/morrisons_logo_white_custom.9bbcac3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/morrisons_logo_white_custom.png
// module id = 585
// module chunks = 0